import { useNavigate } from 'react-router';
import { Plus } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { CompanyDocument, type ICompanyQuery } from 'src/graphql/actions/company/company.query.generated';
import { apolloCache as cache } from 'src/graphql';

const NewEscrowAction = () => {
  const navigate = useNavigate();
  const dataCompany = cache.readQuery<ICompanyQuery>({ query: CompanyDocument });

  if (!dataCompany?.company.policy.createEscrow) return null;

  const handleCreate = () => navigate('/software-escrows/onboarding/new');

  return (
    <Button size="sm" onClick={handleCreate} className="h-10 sm:h-9">
      <Plus />
      <span className="hidden sm:block">New Escrow</span>
    </Button>
  );
};

export default NewEscrowAction;
